import React, { useContext } from "react";
import { useHistory } from "react-router-dom";
import Header from "components/common_components/Header";
import LoadingPage from "components/common_components/LoadingPage";
import Page from "components/common_components/Page";
import FormsContext from "./FormsContext";
import CategoriesContainer from "./components/Categories";
import FormsContainer from "./components/Forms";
import ClientsContainer from "./components/Clients";
import FileCaseSearchContainer from "./components/FileCaseSearch";
import FileCasesContainer from "./components/FileCases";
import ComfirmationContainer from "./components/Comfirmation";
import { SearchBy } from "./components/SearchByToggle";
import clsx from "clsx";

const Steps = {
    Form: "form",
    Subject: "subject",
    FileCase: "fileCase",
    Comfirmation: "comfirmation",
};

const AddWizard = () => {
    const history = useHistory();
    const { resources, isLoadingResources, setAddFormState, addFormState, resetAddFormState } = useContext(FormsContext);
    const { category, form, client, fileCase, searchBy } = addFormState;

    // fileCase: undefined = not decided yet, null = the form will not be associated with a case
    let step = Steps.Comfirmation;
    if (!form) {
        step = Steps.Form;
    } else if (!client) {
        step = Steps.Subject;
    } else if (fileCase === undefined) {
        step = Steps.FileCase;
    }

    const onFormsBackClick = () => {
        resetAddFormState();
    };

    const onComfirm = () => {
        history.push("/forms/add");
    };

    const setCategory = (category) => setAddFormState((prev) => ({ ...prev, category }));
    const setForm = (form) => setAddFormState((prev) => ({ ...prev, form, category: form?.category, client: undefined, fileCase: undefined }));
    const setClient = (client) => setAddFormState((prev) => ({ ...prev, client, fileCase: undefined }));
    const setFileCase = (fileCase) => setAddFormState((prev) => ({ ...prev, fileCase }));
    const setSearchBy = (searchBy) => setAddFormState((prev) => ({ ...prev, searchBy }));

    // Searching by case: the case already tells which client the form is for
    const setFileCaseWithClient = (fileCase) =>
        setAddFormState((prev) => ({
            ...prev,
            client: { id: fileCase.clientId, fullName: fileCase.clientFullName, enabled: fileCase.clientEnabled },
            fileCase,
        }));

    const onComfirmationBackClick = () => {
        if (searchBy === SearchBy.Case) {
            setClient(undefined);
        } else {
            setFileCase(undefined);
        }
    };

    const onCancel = () => {
        resetAddFormState();
        history.goBack();
    };

    return (
        <Page className="add-form-wizard-page">
            <Header title="Create form" />
            {isLoadingResources && <LoadingPage />}
            {!isLoadingResources && (
                <div
                    className={clsx("container", {
                        "in-comfirmation": step === Steps.Comfirmation,
                    })}
                >
                    <CategoriesContainer
                        categories={resources.categories}
                        forms={resources.forms}
                        visible={step === Steps.Form}
                        onChange={setCategory}
                        onBackClick={onCancel}
                    />
                    <FormsContainer visible={step !== Steps.Comfirmation} onClick={setForm} onBackClick={onFormsBackClick} />
                    <ClientsContainer
                        visible={step === Steps.Subject && searchBy !== SearchBy.Case}
                        form={form}
                        onBackClick={() => setForm(null)}
                        onClientSelected={setClient}
                        onSearchByChange={setSearchBy}
                    />
                    <FileCaseSearchContainer
                        visible={step === Steps.Subject && searchBy === SearchBy.Case}
                        form={form}
                        onBackClick={() => setForm(null)}
                        onFileCaseSelected={setFileCaseWithClient}
                        onSearchByChange={setSearchBy}
                    />
                    <FileCasesContainer
                        visible={step === Steps.FileCase}
                        client={client}
                        onBackClick={() => setClient(undefined)}
                        onFileCaseSelected={setFileCase}
                    />
                    <ComfirmationContainer
                        visible={step === Steps.Comfirmation}
                        category={category}
                        form={form}
                        client={client}
                        fileCase={fileCase}
                        onBackClick={onComfirmationBackClick}
                        onContinue={onComfirm}
                    />
                </div>
            )}
        </Page>
    );
};

export default AddWizard;
